import { render } from "./NotificationBar.vue?vue&type=template&id=2f39bc32&scoped=true"
import script from "./NotificationBar.vue?vue&type=script&lang=js"
export * from "./NotificationBar.vue?vue&type=script&lang=js"

import "./NotificationBar.vue?vue&type=style&index=0&id=2f39bc32&lang=scss"
import "./NotificationBar.vue?vue&type=style&index=1&id=2f39bc32&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f39bc32"]])

export default __exports__